import React, { useEffect } from "react";
import Dashboard from "../../Dashboard_en/Dashboard";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import ApiName from "../../ApiName";
import { 
  LayoutDashboard, 
  Palette, 
  Image as ImageIcon, 
  Info, 
  Tags, 
  ClipboardList 
} from "lucide-react";

const authCheck = async (navigate) => {
  try {
    const response = await fetch(`${ApiName}/Auth/authCheck`, {
      method: "GET",
      headers: {
        Authorization: localStorage.getItem("authToken"),
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      localStorage.setItem("isAuthenticated", "true");
    } else {
      throw new Error("Not authenticated");
    }
  } catch (error) {
    localStorage.setItem("isAuthenticated", "false");
    navigate("/login");
  }
};

const AdminMain = () => {
  const navigate = useNavigate();

  useEffect(() => {
    authCheck(navigate);
  }, [navigate]);

  const sidebarButtons = [
    {
      text: "Dashboard",
      pageLink: "/admin/dashboard",
      icon: <LayoutDashboard size={20} strokeWidth={1.5} />,
    },
    {
      text: "Paint Management",
      pageLink: "/admin/paints",
      icon: <Palette size={20} strokeWidth={1.5} />,
    },
    {
      text: "Home Management",
      pageLink: "/admin/settings/homeImages",
      icon: <ImageIcon size={20} strokeWidth={1.5} />,
    },
    {
      text: "About Management",
      pageLink: "/admin/settings/about",
      icon: <Info size={20} strokeWidth={1.5} />,
    },
    {
      text: "Category Management",
      pageLink: "/admin/categories",
      icon: <Tags size={20} strokeWidth={1.5} />,
    },
    {
      text: "Audit Logs",
      pageLink: "/admin/audit-logs",
      icon: <ClipboardList size={20} strokeWidth={1.5} />,
    },
  ];

  return localStorage.getItem("isAuthenticated") === "true" ? (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Dashboard sidebarButtons={sidebarButtons}>
        <Outlet />
      </Dashboard>
    </div>
  ) : (
    <Navigate to={"/login"} />
  );
};

export default AdminMain;
